export const SECURITY_REPORT_TITLE = 'securityReport.title';
export const SECURITY_FOOTER_LINK = 'security.footerLink';
